import React from "react";
import SendIcon from "@material-ui/icons/Send";
import CallIcon from "@material-ui/icons/Call";
import MailIcon from "@material-ui/icons/Mail";
import "./css/Footer.css";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import FacebookIcon from "@material-ui/icons/Facebook";
import YouTubeIcon from "@material-ui/icons/YouTube";
import InstagramIcon from "@material-ui/icons/Instagram";

function Footer() {
  return (
    <footer>
      <div className="footer">
        <div className="footer-content">
          <div className="footer-email">
            <div className="footer-email-content">
              <p className="email">Subscribe To Our News Letter</p>
              <p className="email-content">
                Enter your email get notified about the new courses.
              </p>
              <div className="email-input">
                <input placeholder="Email Address"></input>
                <div className="send">
                  <SendIcon />
                </div>
              </div>
            </div>
          </div>
          <div className="footer-contacts">
            <div className="footer-contacts-content">
              <p className="contact">Contact Us</p>
              <p className="call">
                <span>
                  <CallIcon />
                </span>
                +91-9599419168
              </p>
              <p className="call">
                <span>
                  <MailIcon />
                </span>
                codewithakky@gmail.com
              </p>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-links-content">
              <p className="links">Important Links</p>
              <p className="link">Blog</p>
              <p className="link">Courses</p>
              <p className="link">About Us</p>
              <p className="link">Login/SignUp</p>
            </div>
          </div>
          <div className="footer-categories">
            <div className="footer-categories-content">
              <p className="categories">Categories</p>
              <p className="cate">Programming</p>
              <p className="cate">Soft Skills</p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-strip">
        <div className="footer-strip-brand">
          <p>
            @ Code With Akky Pvt Ltd |<br />
            All Rights Reserved &copy; 2021-22
          </p>
        </div>
        <div className="footer-strip-socials">
          <div className="footer-strip-social">
            <TwitterIcon />
          </div>
          <div className="footer-strip-social">
            <FacebookIcon />
          </div>
          <div className="footer-strip-social">
            <InstagramIcon />
          </div>
          <div className="footer-strip-social">
            <YouTubeIcon />
          </div>
          <div className="footer-strip-social">
            <LinkedInIcon />
          </div>
        </div>
        <div className="terms">
          <p>Terms and Conditions</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
